module.exports = __webpack_public_path__ + "media/Audio19_f.a2420966.wav";